module.exports = __webpack_public_path__ + "static/media/discount-type.494ba8ec.svg";